<template>
  <div class="general-ledger setting-component">
    <div class="setting-component__filter-block">
      <div class="tabs-wrapper">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane name="summary" label="Summary">
            <g-l-a-summary ref="summary"/>
          </el-tab-pane>
          <!-- <el-tab-pane name="organisation" label="Organisation">
            <g-l-a-organisation ref="organisation"></g-l-a-organisation>
          </el-tab-pane> -->
          <el-tab-pane name="details" label="Details">
            <g-l-a-details ref="details"/>
          </el-tab-pane>
          <!-- <el-tab-pane name="subsidiary" label="Subsidiary">
            <g-l-a-subsidiary ref="subsidiary"></g-l-a-subsidiary>
          </el-tab-pane> -->
          <el-tab-pane name="budget" label="Budget">
            <g-l-a-budget v-if="activeTab === 'budget'" ref="budget" />
          </el-tab-pane>
          <el-tab-pane disabled name="analysis" label="Analysis">
          </el-tab-pane>
        </el-tabs>
        <div class="buttons-block">
          <el-button size="mini" @click="openJournals">Journals</el-button>
          <el-button size="mini" @click="routerLink('settings-coa-view')">COA</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
// import { AgGridVue } from "ag-grid-vue";
// import axios from "axios";
// import ActionCellRenderer from "@/components/settings/settingsGlAccounts2/actionCellRenderer.vue";
// import COAAddGroupModal from "@/components/settings/settingsGlAccounts2/COAAddGroupModal";
// import COAAddClassModal from "@/components/settings/settingsGlAccounts2/COAAddClassModal";
// import COAAddAccountModal from "@/components/settings/settingsGlAccounts2/COAAddAccountModal";
// import COAAddSubAccountModal from "@/components/settings/settingsGlAccounts2/COAAddSubAccountModal";
// import OpeningCellRenderer from "@/components/settings/settingsGlAccounts2/openingCellRenderer";
// import DebitCellRenderer from "@/components/settings/settingsGlAccounts2/debitCellRenderer";
// import CreditCellRenderer from "@/components/settings/settingsGlAccounts2/creditCellRenderer";
// import EndingBalanceCellRenderer from "@/components/settings/settingsGlAccounts2/endingBalanceCellRenderer";
// import ForeignBalanceCellRenderer from "@/components/settings/settingsGlAccounts2/foreignBalanceCellRenderer";
// import COAAddAccountTransactionModal2 from "@/components/settings/settingsGlAccounts2/ClientsVendorsSimpleAccount/COAAddAccountTransactionModal2";
// import COAAddAccountTransactionModal3 from "@/components/settings/settingsGlAccounts2/SimpleAccount/COAAddAccountTransactionModal3";
// import COAAddMultiCurrencyAccountTransactionModal from "@/components/settings/settingsGlAccounts2/MultiCurrencyAccount/COAAddMultiCurrencyAccountTransactionModal";
// import GenerallLedgerDetailedModal from "@/components/settings/settingsGlAccounts2/GenerallLedgerDetailedModal";
// import COAAddVendorClientMultiCurrencyAccountTransactionModal from "@/components/settings/settingsGlAccounts2/ClientsVendorsMultiCurrencyAccount/COAAddVendorClientMultiCurrencyAccountTransactionModal";
// import CreateTaxAccountModal from "@/components/settings/settingsGlAccounts2/createTaxAccountModal";
// import AssignTaxAccountModal from "@/components/settings/settingsGlAccounts2/assignTaxAccountModal";
// import resize from "vue-resize-directive";
// import { ObserveVisibility } from "vue-observe-visibility";
// import downloadexcel from "vue-json-excel";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import GeneralLedgerIncomeStatement from "../components/settings/settingsGlAccounts2/GeneralLedgerIncomeStatement";
import GLADetails from "../components/settings/settingsGlAccounts2/glaTabs/GLADetails";
import GLAOrganisation from "../components/settings/settingsGlAccounts2/glaTabs/GLAOrganisation";
import GLASubsidiary from "../components/settings/settingsGlAccounts2/glaTabs/GLASubsidiary";
import GLASummary from "../components/settings/settingsGlAccounts2/glaTabs/GLASummary";
import GLABudget from "@/components/settings/settingsGlAccounts2/glaTabs/GLABudget.vue";
// const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY
export default {
  name: "GeneralLendger",
  // directives: {
  //   resize,
  //   "observe-visibility": ObserveVisibility,
  // },
  computed: {
    // companyLayout() {
    //   return this.$store.getters.getCompanyLayout;
    // },
    // financialYearStartDate() {
    //   return this.companyLayout ? this.companyLayout.financialYearStartDate : null
    // },
    // taxAccounts() {
    //   return this.rowData.filter(
    //     (val) => val.entityType === "account" && val.taxId
    //   );
    // },
    // incomeStatement() {
    //   return this.doc.length ? this.doc[this.doc.length - 1] : null;
    // },
    // balanceSheet() {
    //   return this.balanceSheetDoc.length
    //     ? this.balanceSheetDoc[this.balanceSheetDoc.length - 1]
    //     : null;
    // },
    // trialBalance() {
    //   return this.trialBalanceDoc.length
    //     ? this.trialBalanceDoc[this.trialBalanceDoc.length - 1]
    //     : null;
    // },
    // activeCompanyName() {
    //   return this.$store.state.activeCompanyName;
    // },
  },
  data() {
    return {
      // moment: moment,
      // filters: {
      //   shownColumns: [],
      // },
      // showColumnsList: [
      //   {
      //     columns: ["amount"],
      //     toHideColumns: [],
      //     name: (val) => `${val} Opening`,
      //   },
      //   {
      //     columns: ["credit", "debit"],
      //     toHideColumns: ["endingBalance"],
      //     name: () => "Trial Balance View",
      //   },
      //   {
      //     columns: ["currencycode", "exchangeRate", "foreignBalance"],
      //     toHideColumns: [],
      //     name: () => "Foreign Currency",
      //   },
      // ],
      // doc: [],
      // balanceSheetDoc: [],
      // trialBalanceDoc: [],
      // filter: {
      //   datesType: "None",
      //   datesType2: null,
      //   datesType3: null,
      //   dates: [],
      //   dates2: [],
      //   dates3: [],
      //   asAtDate: moment(),
      // },
      // datepickerSetAsOptions: {
      //   disabledDate: this.disabledDueDate
      // },
      // datesTypes: ["None", "This financial quarter", "Last financial quarter"],
      // whatToShowList: [
      //   { id: 1, name: this.$i18n.t("settings_businessCenters") },
      //   { id: 2, name: this.$i18n.t("settings_businessUnits") },
      //   { id: 3, name: this.$i18n.t("settings_warehouses") },
      //   { id: 4, name: this.$i18n.t("settings_engagements") },
      //   { id: 5, name: this.$i18n.t("settings_projects") },
      //   { id: 6, name: this.$i18n.t("settings_employee") },
      // ],
      // rowData: [],
      // rowData2: [],
      // allRowData: [],
      // grid settings
      // gridOptions: null,
      // gridOptions2: null,
      // getDataPath: null,
      // getRowNodeId: null,
      // getRowHeight: null,
      // autoGroupColumnDef: null,
      // columnDefs: null,
      // gridColumnApi: null,
      // gridColumnApi2: null,
      // domLayout: "autoHeight",
      // gridApi: null,
      // gridApi2: null,
      // defaultColDef: null,
      // pinnedBottomRowData: null,
      // pinnedBottomRowData2: null,
      // groupDefaultExpanded: -1,
      // context: null,
      // rowSelection: "multiple",
      // currencyList: [],
      // LeaderLineOptions: {
      //   path: "grid",
      //   size: 2,
      // },
      // liner1: null,
      // liner2: null,
      // liner3: null,
      // liner4: null,
      // liner5: null,
      // liner6: null,
      // isVisible: true,
      // isBottomVisible: true,
      // hideSumRow: false,
      // hideBottomSumRow: false,
      // clashflowArr: [],
      activeTab: "summary",
      // json_fields: {
      //   Type: "type",
      //   Class: "class",
      //   Group: "group",
      //   Account: "account",
      //   Amount: "amount",
      // },
      // json_fields2: {
      //   Type: "type",
      //   Class: "class",
      //   Group: "group",
      //   Account: "account",
      // },
      // json_fields4: {
      //   Type: "type",
      //   Class: "class",
      //   Group: "group",
      //   Account: "account",
      //   Credit: "credit",
      //   Debit: "debit",
      // },
      // isBalanceSheet: false,
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "This month",
      //       onClick(picker) {
      //         const end = moment().endOf("month");
      //         const start = moment().startOf("month");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "Last month",
      //       onClick(picker) {
      //         const end = moment().endOf("month").subtract(1, "months");
      //         const start = moment().startOf("month").subtract(1, "months");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "Last 3 months",
      //       onClick(picker) {
      //         const end = moment().endOf("month").subtract(1, "months");
      //         const start = moment().startOf("month").subtract(3, "months");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "This financial quarter",
      //       onClick(picker) {
      //         const end = moment().endOf("quarter");
      //         const start = moment().startOf("quarter");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "Last financial quarter",
      //       onClick(picker) {
      //         const end = moment().subtract(1, 'quarter').endOf('quarter');
      //         const start = moment().subtract(1, 'quarter').startOf('quarter');
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "This financial year",
      //       onClick(picker) {
      //         const end = moment().endOf("year");
      //         const start = moment().startOf("year");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "Last financial year",
      //       onClick(picker) {
      //         const end = moment().endOf("year").subtract(1, "year");
      //         const start = moment().startOf("year").subtract(1, "year");
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //   ],
      // },
      // currencies:[],
      // foreignCurrencyId: null
    };
  },
  components: {
    GLABudget,
    GLASummary,
    GLADetails,
    GLAOrganisation,
    GLASubsidiary,
    // GeneralLedgerIncomeStatement,
    // downloadexcel,
    // AssignTaxAccountModal,
    // CreateTaxAccountModal,
    // COAAddVendorClientMultiCurrencyAccountTransactionModal,
    // COAAddMultiCurrencyAccountTransactionModal,
    // GenerallLedgerDetailedModal,
    // COAAddAccountTransactionModal3,
    // COAAddAccountTransactionModal2,
    // COAAddSubAccountModal,
    // COAAddAccountModal,
    // COAAddClassModal,
    // COAAddGroupModal,
    // AgGridVue,
    // actionCellRenderer: ActionCellRenderer,
    // openingCellRenderer: OpeningCellRenderer,
    // debitCellRenderer: DebitCellRenderer,
    // creditCellRenderer: CreditCellRenderer,
    // endingBalanceCellRenderer: EndingBalanceCellRenderer,
    // foreignBalanceCellRenderer: ForeignBalanceCellRenderer
  },
  // beforeMount() {
  //   this.gridOptions = {
  //     suppressCellSelection: true,
  //   };
  //   this.gridOptions2 = {
  //     suppressCellSelection: true,
  //   };
  //   this.getDataPath = (data) => {
  //     return data.filePath;
  //   };
  //   this.getRowNodeId = (data) => {
  //     return data.id;
  //   };
  //   this.getRowHeight = (params) => {
  //     return 30;
  //   };
  //   this.autoGroupColumnDef = {
  //     headerName: this.$i18n.t("settings_accountThink_GLAccounts_accountsList"),
  //     field: "name",
  //     suppressMenu: true,
  //     // width: 110,
  //     cellRendererParams: {
  //       suppressCount: true,
  //       innerRenderer: function (params) {
  //         return `<span class="account-list-text grid-text">${params.node.data.name}</span>`;
  //       },
  //     },
  //     cellClass: "account-list",
  //     cellStyle: {
  //       "border-right-color": "#e2e2e2",
  //       "padding-left": "10px",
  //       "align-items": "center",
  //       display: "flex",
  //     },
  //   };
  //   this.columnDefs = [
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_dbCode"),
  //       field: "code",
  //       suppressMenu: true,
  //       width: 90,
  //       headerClass: "db-code-header",
  //       cellClass: "db-code",
  //       cellStyle: function (params) {
  //         return {
  //           "align-items":
  //             "center; display: flex; padding-left: 10px; border-right-color: #e2e2e2;",
  //         };
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_accNo"),
  //       field: "number",
  //       cellClass: "acc-no",
  //       suppressMenu: true,
  //       width: 70,
  //       headerClass: "acc-no-header center-header",
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_report"),
  //       field: "report",
  //       headerClass: "report-header center-header",
  //       suppressMenu: true,
  //       width: 75,
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_opening"),
  //       field: "amount",
  //       headerClass: "opening-header center-header",
  //       width: 100,
  //       suppressMenu: true,
  //       aggFunc: (params) => {
  //         let result = 0;
  //         params.forEach(function (value) {
  //           if (typeof value === "number") {
  //             console.log(value);
  //             result += value;
  //           }
  //         });
  //         return result;
  //       },
  //       cellRendererFramework: "openingCellRenderer",
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: "Ending Balance",
  //       field: "endingBalance",
  //       headerClass: "current-debit-header center-header",
  //       width: 110,
  //       suppressMenu: true,
  //       cellRendererFramework: "endingBalanceCellRenderer",
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t(
  //         "settings_accountThink_GLAccounts_currentDebit"
  //       ),
  //       field: "debit",
  //       headerClass: "current-debit-header center-header",
  //       width: 110,
  //       suppressMenu: true,
  //       cellRendererFramework: "debitCellRenderer",
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t(
  //         "settings_accountThink_GLAccounts_balanceCredit"
  //       ),
  //       field: "credit",
  //       headerClass: "balance-credit-header center-header",
  //       width: 110,
  //       suppressMenu: true,
  //       cellRendererFramework: "creditCellRenderer",
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_setAs"),
  //       field: "DRCRCode",
  //       suppressMenu: true,
  //       headerClass: "set-as-header center-header",
  //       width: 50,
  //       cellClass: "set-as-cell",
  //       cellRenderer: function (params) {
  //         return `<div class="grid-text set-as-text">
  //                   <span class="dr-text">
  //                     ${params.node.data.DRCRCode === "DR" ? "DR" : ""}
  //                   </span>
  //                   <span class="cr-text">
  //                     ${params.node.data.DRCRCode === "CR" ? "CR" : ""}
  //                   </span>
  //                 </div>`;
  //       },
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_tax"),
  //       headerClass: "tax-header center-header",
  //       field: "nameTax",
  //       suppressMenu: true,
  //       width: 100,
  //       cellStyle: {
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: this.$i18n.t("settings_accountThink_GLAccounts_currency"),
  //       field: "currencycode",
  //       headerClass: "currency-header center-header",
  //       suppressMenu: true,
  //       width: 70,
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: "Cashflow",
  //       field: "clashflowObj.name",
  //       width: 100,
  //       headerClass: "type-header center-header",
  //       suppressMenu: true,
  //       cellRenderer: function (params) {
  //         return `<span class="grid-text type-text">${
  //           params.node.data.clashflowObj
  //             ? params.node.data.clashflowObj.name
  //             : ""
  //         }</span>`;
  //       },
  //       cellStyle: {
  //         "border-right-color": "#e2e2e2",
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: "Exchange rate",
  //       headerClass: "tax-header center-header",
  //       field: "exchangeRate",
  //       suppressMenu: true,
  //       width: 100,
  //       cellStyle: {
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //     {
  //       suppressSizeToFit: true,
  //       headerName: "Foreign Balance",
  //       headerClass: "tax-header center-header",
  //       field: "foreignBalance",
  //       cellRendererFramework: "foreignBalanceCellRenderer",
  //       suppressMenu: true,
  //       width: 100,
  //       cellStyle: {
  //         "align-items": "center",
  //         display: "flex",
  //         "justify-content": "center",
  //       },
  //     },
  //   ];
  //   this.defaultColDef = {
  //     editable: (node) => {
  //       if (node.colDef.cellClass === "acc-no") {
  //         return true;
  //       }
  //       if (node.colDef.cellClass === "account-list") {
  //         return true;
  //       }
  //     },
  //     onCellValueChanged: (node) => {
  //       if (!node.newValue) {
  //         console.log("node", node);
  //         return;
  //       }
  //       // alert('hello')
  //     },
  //   };
  //   this.rowSelection = "multiple";
  //   this.context = { componentParent: this };
  // },
  mounted() {
    this.$nextTick(() => {
      this.$refs.summary.loadList2()
    })
  },
  // mounted() {
  //   this.gridColumnApi = this.gridOptions.columnApi;
  //   this.gridColumnApi2 = this.gridOptions2.columnApi;
  //   this.gridColumnApi.moveColumn("code", 0);
  //   this.gridColumnApi.moveColumn("number", 1);
  //   this.gridColumnApi2.moveColumn("code", 0);
  //   this.gridColumnApi2.moveColumn("number", 1);
  //   this.gridApi = this.gridOptions.api;
  //   this.gridApi2 = this.gridOptions2.api;
  //   this.gridApi.sizeColumnsToFit();
  //   this.gridApi2.sizeColumnsToFit();
  //   this.loadCompanyInfo();
  //   if (this.companyLayout && this.companyLayout.financialYearStartDate) {
  //     this.filter.dates = [
  //       this.companyLayout.financialYearStartDate
  //         ? moment(this.companyLayout.financialYearStartDate, "DD-MM-yyyy")
  //         : moment("2022-01-01", "DD-MM-yyyy"),
  //       moment(),
  //     ];
  //     this.downloadDoc(
  //       this.filter.dates[0].format("yyyy-MM-DD"),
  //       this.filter.dates[1].format("yyyy-MM-DD")
  //     );
  //     this.downloadBalanceSheetDoc(
  //       this.filter.dates[0].format("yyyy-MM-DD"),
  //       this.filter.dates[1].format("yyyy-MM-DD")
  //     );
  //     this.downloadTrialBalanceDoc(
  //       this.filter.dates[0].format("yyyy-MM-DD"),
  //       this.filter.dates[1].format("yyyy-MM-DD")
  //     );
  //     this.loadList(
  //       this.filter.dates[0].format("yyyy-MM-DD"),
  //       this.filter.dates[1].format("yyyy-MM-DD")
  //     );
  //   }
  //   this.getCurrencies()
  // },
  methods: {
    handleTabClick(tab, event) {
      switch (tab.name) {
        case 'summary':
          this.$refs.summary.loadList2()
          break;
        case 'details':
          this.$refs.details.loadList2()
          break;
        case 'organisation':
          this.$refs.organisation.loadList2()
          break;
        case 'subsidiary':
          this.$refs.subsidiary.loadList2()
          break;
      }
    },
    openJournals() {
      this.$router.push(
        `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=journalReport`
      );
    },
    routerLink(page) {
      this.$router.push({
        name: page,
        query: { companyId: this.$route.query.companyId },
      });
    }
  },
  // methods: {
  //   onGridReady(params) {
  //     params.api.sizeColumnsToFit();
  //   },
  //   onGridReady2(params) {
  //     params.api.sizeColumnsToFit();
  //   },
  //   routerLink(page) {
  //     this.$router.push({
  //       name: page,
  //       query: { companyId: this.$route.query.companyId },
  //     });
  //   },
  //   loadList(stateStart, stateEnd) {
  //     return new Promise((resolve, reject) => {
  //       const start = stateStart
  //         ? stateStart
  //         : this.companyLayout.financialYearStartDate
  //         ? moment(
  //             this.companyLayout.financialYearStartDate,
  //             "DD-MM-yyyy"
  //           ).format("yyyy-MM-DD")
  //         : moment("2022-01-01", "DD-MM-yyyy").format("yyyy-MM-DD");
  //       const end = stateEnd ? stateEnd : moment().format("yyyy-MM-DD");
  //       let loader = this.$loading.show();
  //       axios.defaults.headers.common["Authorization"] =
  //         "Bearer " + sessionStorage.getItem("token");
  //       axios.defaults.headers.common["X-Timezone-Offset"] = (
  //         new Date().getTimezoneOffset() / 60
  //       ).toString();
  //       axios
  //         .get(
  //           `/api/v1/accountDoubleTree/get?companyId=${this.$route.query.companyId}&startDate=${start}&endDate=${end}`
  //         )
  //         .then((response) => {
  //           console.log("response", response.data.tree);
  //           this.rowData = response.data.doubleTree[1].map((val) => ({
  //             ...val,
  //             ...{
  //               endingBalance: val.DRCRCode === 'CR' ? val.credit : val.debit,
  //               exchangeRate: null,
  //               foreignBalance: null,
  //             },
  //           }));
  //           this.rowData2 = response.data.doubleTree[0].map((val) => ({
  //             ...val,
  //             ...{
  //               endingBalance: val.DRCRCode === 'CR' ? val.credit : val.debit,
  //               exchangeRate: null,
  //               foreignBalance: null,
  //             },
  //           }));
  //           this.allRowData = response.data.doubleTree[1].concat(
  //             response.data.doubleTree[0]
  //           );
  //           // this.clashflowArr = response.data.tree.clashflowArr
  //           // this.tableData = list
  //           const hideColumns = [
  //             "amount",
  //             "credit",
  //             "debit",
  //             "currencycode",
  //             "clashflowObj.name",
  //             "exchangeRate",
  //             "foreignBalance",
  //           ];
  //
  //           if (this.filters.shownColumns.length) {
  //             this.showColumnsList.forEach((bal, index) => {
  //               this.toggleColumns(bal.columns, bal.toHideColumns, index)
  //             })
  //           } else {
  //             this.gridColumnApi.setColumnsVisible(hideColumns, false);
  //             this.gridColumnApi2.setColumnsVisible(hideColumns, false);
  //           }
  //           this.gridApi.sizeColumnsToFit();
  //           this.gridApi2.sizeColumnsToFit();
  //           console.log(this.accountList);
  //           loader.hide();
  //           resolve(response.data);
  //         })
  //         .catch((error) => {
  //           console.log("An error occurred:", error);
  //           loader.hide();
  //         });
  //       this.gridApi.sizeColumnsToFit();
  //       this.gridApi2.sizeColumnsToFit();
  //     });
  //   },
  //   async loadListAfterCreate({ entityType, id }) {
  //     try {
  //       await this.loadList();
  //       await this.selectCreatedTask(entityType, id);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   },
  //   closeModal() {
  //     // this.liner5.color = 'coral'
  //     // this.liner6.color = 'coral'
  //     // this.liner1.color = 'coral'
  //     // this.liner4.color = 'coral'
  //   },
  //   selectCreatedTask(entityType, id) {
  //     return new Promise((resolve, reject) => {
  //       this.gridApi.forEachNode((node, index) => {
  //         // CHECK IF USER HAVE ACCESS TO TE ROW
  //         if (node.data.entityType === entityType && node.data.id === id) {
  //           // MOVE TASK TO MIDDLE CENTER
  //           this.gridApi.ensureIndexVisible(node.rowIndex, "middle");
  //           node.setSelected(true);
  //           resolve(node);
  //         }
  //       });
  //       this.gridApi2.forEachNode((node, index) => {
  //         // CHECK IF USER HAVE ACCESS TO TE ROW
  //         if (node.data.entityType === entityType && node.data.id === id) {
  //           // MOVE TASK TO MIDDLE CENTER
  //           this.gridApi2.ensureIndexVisible(node.rowIndex, "middle");
  //           node.setSelected(true);
  //           resolve(node);
  //         }
  //       });
  //     });
  //   },
  //   loadCompanyInfo() {
  //     let loader = this.$loading.show();
  //     axios.defaults.headers.common["Authorization"] =
  //       "Bearer " + sessionStorage.getItem("token");
  //     axios.defaults.headers.common["X-Timezone-Offset"] = (
  //       new Date().getTimezoneOffset() / 60
  //     ).toString();
  //     axios
  //       .post(
  //         `/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`
  //       )
  //       .then((response) => {
  //         this.currencyList = response.data.currencyList;
  //         loader.hide();
  //       })
  //       .catch((error) => {
  //         console.log("An error occurred:", error);
  //         loader.hide();
  //       });
  //   },
  //   toggleShowActiveAccountsOnly(val) {
  //     console.log(val);
  //   },
  //   methodFromActionCell(action, params) {
  //     switch (action) {
  //       case "delete":
  //         return this.deleteNode(params.node.data);
  //       case "add":
  //         if (params.node.data.entityType === "type")
  //           return this.$refs.coaAddClassModal.openModal("create", params);
  //         if (params.node.data.entityType === "class")
  //           return this.$refs.coaAddGroupModal.openModal("create", params);
  //         if (params.node.data.entityType === "group")
  //           return this.$refs.coaAddAccountModal.openModal("create", params);
  //         if (params.node.data.entityType === "account")
  //           return this.$refs.coaAddSubAccountModal.openModal("create", params);
  //         if (params.node.data.entityType === "sub-account")
  //           return this.$refs.coaAddSubAccountModal.openModal("create", params);
  //         break;
  //       case "update":
  //         if (params.node.data.entityType === "class")
  //           return this.$refs.coaAddClassModal.openModalEdit("update", params);
  //         if (params.node.data.entityType === "group")
  //           return this.$refs.coaAddGroupModal.openModalEdit("update", params);
  //         if (params.node.data.entityType === "account")
  //           return this.$refs.coaAddAccountModal.openModalEdit(
  //             "update",
  //             params
  //           );
  //         if (params.node.data.entityType === "sub-account")
  //           return this.$refs.coaAddSubAccountModal.openModalEdit(
  //             "update",
  //             params
  //           );
  //         break;
  //       case "create-tax-account":
  //         this.$refs.createTaxAccountModal.openModal(params);
  //         break;
  //       case "assign-tax":
  //         this.$refs.assignTaxAccountModal.openModal(params);
  //         break;
  //     }
  //   },
  //   openAccountTransactionModal(params) {
  //     console.log("params", params);
  //     // find groups [RECEIVABLES/id-84, ACCOUNTS PAYABLE/id-102]
  //     console.log(
  //       "group id",
  //       params.node.data.filePath[2],
  //       params.node.data.filePath
  //     );
  //     const group = this.allRowData.find(
  //       (val) =>
  //         val.id === params.node.data.filePath[2] && val.entityType === "group"
  //     );
  //     console.log(
  //       "group",
  //       group,
  //       params.node.data,
  //       params.node.data.accountCurrencyId
  //     );
  //     if (group.code === "1.1.3" || group.code === "2.1.1") {
  //
  //       if (
  //         params.node.data.accountCurrencyId &&
  //         params.node.data.accountCurrencyId !== this.companyLayout.currency.id
  //       ) {
  //         params.node.data.amount
  //           ? this.$refs.coaAddVendorClientMultiCurrencyAccountTransactionModal.openModalEdit(
  //               params
  //             )
  //           : this.$refs.coaAddVendorClientMultiCurrencyAccountTransactionModal.openModal(
  //               params
  //             );
  //       } else {
  //         params.node.data.amount
  //           ? this.$refs.coaAddAccountTransactionModal2.openModalEdit(params)
  //           : this.$refs.coaAddAccountTransactionModal2.openModal(params);
  //       }
  //     } else {
  //       if (
  //         params.node.data.accountCurrencyId &&
  //         params.node.data.accountCurrencyId !== this.companyLayout.currency.id
  //       ) {
  //         params.node.data.amount
  //           ? this.$refs.coaAddMultiCurrencyAccountTransactionModal.openModalEdit(
  //               params
  //             )
  //           : this.$refs.coaAddMultiCurrencyAccountTransactionModal.openModal(
  //               params
  //             );
  //       } else {
  //         params.node.data.amount
  //           ? this.$refs.coaAddAccountTransactionModal3.openModalEdit(params)
  //           : this.$refs.coaAddAccountTransactionModal3.openModal(params);
  //       }
  //     }
  //   },
  //   openGenerallLedgerDetailedModal(params) {
  //     this.$refs.generallLedgerDetailedModal.openModal(params);
  //   },
  //   clickIncomeStatements() {
  //     if (this.isBottomVisible) {
  //       this.isBottomVisible = false;
  //     } else {
  //       this.isBottomVisible = true;
  //     }
  //   },
  //   selectIncomeStatementQuarter(period) {
  //     let start = null;
  //     let end = null;
  //     switch (period) {
  //       case "This financial quarter":
  //         end = moment().endOf("quarter").format("yyyy-MM-DD");
  //         start = moment().startOf("quarter").format("yyyy-MM-DD");
  //         break;
  //       case "Last financial quarter":
  //         end = moment().subtract(1, 'quarter').endOf('quarter');
  //         start = moment().subtract(1, 'quarter').startOf('quarter');
  //         break;
  //     }
  //     this.$refs.generalLedgerIncomeStatementModal.openModal(
  //       start,
  //       end,
  //       "QUARTERLY"
  //     );
  //   },
  //   clickBalanceSheet() {
  //     if (this.isVisible) {
  //       // this.liner4.color = 'transparent'
  //       this.isVisible = false;
  //     } else {
  //       this.isVisible = true;
  //       // this.liner4.color = 'coral'
  //     }
  //   },
  //   deleteNode(data) {
  //     let url = null;
  //     switch (data.entityType) {
  //       case "class":
  //         url = `/api/v1/accountClass/delete?classId=${data.id}`;
  //         break;
  //       case "group":
  //         url = `/api/v1/accountGroup/delete?groupId=${data.id}`;
  //         break;
  //       case "account":
  //       case "sub-account":
  //         url = `/api/v1/account/delete?companyId=${this.$route.query.companyId}&accountId=${data.id}`;
  //     }
  //     console.log("data name", data.name);
  //     this.$confirm(
  //       this.$t("settings_accountThink_deleteName", { name: data.name }),
  //       this.$t("general_warning"),
  //       {
  //         confirmButtonText: this.$t("general_ok"),
  //         cancelButtonText: this.$t("general_cancel"),
  //         type: "info",
  //       }
  //     ).then(() => {
  //       let loader = this.$loading.show();
  //       axios.defaults.headers.common["Authorization"] =
  //         "Bearer " + sessionStorage.getItem("token");
  //       axios.defaults.headers.common["X-Timezone-Offset"] = (
  //         new Date().getTimezoneOffset() / 60
  //       ).toString();
  //       axios
  //         .get(url)
  //         .then((response) => {
  //           this.notification(
  //             this.$t("general_success"),
  //             this.$t("notification_nodeRemoved", { name: data.name }),
  //             "success"
  //           );
  //           this.loadList();
  //           loader.hide();
  //         })
  //         .catch((error) => {
  //           console.log("An error occurred:", error);
  //           loader.hide();
  //         });
  //     });
  //   },
  //   notification(title, message, type) {
  //     this.$notify({
  //       title: title,
  //       message: message,
  //       type: type,
  //     });
  //   },
  //   onSelectionChanged(api) {
  //     console.log(api);
  //   },
  //   onRowClicked(api) {
  //     // this.filters.entityTypes = []
  //   },
  //   loadGraphicks() {
  //     // this.liner1 = LeaderLine.setLine(
  //     //     document.getElementById('report'),
  //     //     document.getElementById('balance-sheet'),
  //     //     {...this.LeaderLineOptions, ...{ startSocket: 'top' }}
  //     // );
  //     // this.liner2 = LeaderLine.setLine(
  //     //     document.getElementById('credit-debit'),
  //     //     document.getElementById('total-balance'),
  //     //     {...this.LeaderLineOptions, ...{ startSocket: 'top' }}
  //     // );
  //     // this.liner3 = LeaderLine.setLine(
  //     //     document.getElementById('credit-debit-top'),
  //     //     document.getElementById('total-balance'),
  //     //     {...this.LeaderLineOptions, ...{ startSocket: 'bottom' }}
  //     // );
  //     // this.liner4 = LeaderLine.setLine(
  //     //     document.getElementById('report-top'),
  //     //     document.getElementById('incoming-statement'),
  //     //     {...this.LeaderLineOptions, ...{
  //     //       startSocket: 'bottom'
  //     //     }}
  //     // );
  //     // console.log('liner1', this.liner1)
  //   },
  //   loadBottomGraphicks() {
  //     // this.liner5 = LeaderLine.setLine(
  //     //     document.getElementById('report-2'),
  //     //     document.getElementById('statement-of-cashflows'),
  //     //     {...this.LeaderLineOptions, ...{ startSocket: 'bottom' }}
  //     // );
  //     // this.liner6 = LeaderLine.setLine(
  //     //     document.getElementById('credit-debit-bottom'),
  //     //     document.getElementById('trial-balance'),
  //     //     {...this.LeaderLineOptions, ...{ startSocket: 'bottom' }}
  //     // );
  //   },
  //   removeGraphics() {
  //     // this.liner1.remove()
  //     // this.liner2.remove()
  //     // this.liner3.remove()
  //     // this.liner4.remove()
  //   },
  //   removeBottomGraphicks() {
  //     // this.liner5.remove()
  //     // this.liner6.remove()
  //   },
  //   onResizePage(val) {
  //     // console.log('--', val)
  //     this.gridApi.sizeColumnsToFit();
  //     this.gridApi2.sizeColumnsToFit();
  //     if (this.isVisible) {
  //       // this.liner1.position();
  //       // this.liner2.position();
  //       // this.liner3.position();
  //       // this.liner4.position();
  //     }
  //     if (this.isBottomVisible) {
  //       // this.liner5.position();
  //       // this.liner6.position();
  //     }
  //   },
  //   sumBlocksVisibilityChanged(isVisible, entry) {
  //     this.isVisible = isVisible;
  //     if (isVisible) {
  //       this.loadGraphicks();
  //     } else {
  //       this.removeGraphics();
  //     }
  //   },
  //   sumBottomBlocksVisibilityChanged(isVisible, entry) {
  //     this.isBottomVisible = isVisible;
  //     if (isVisible) {
  //       this.loadBottomGraphicks();
  //     } else {
  //       this.removeBottomGraphicks();
  //     }
  //   },
  //   formatPrice(value) {
  //     let val = (value / 1).toFixed(2).replace(",", ".");
  //     return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   },
  //   openATDashboard() {
  //     this.$router.push(
  //       `/account-think?companyId=${this.$route.query.companyId}`
  //     );
  //   },
  //   openJournals() {
  //     this.$router.push(
  //       `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`
  //     );
  //   },
  //   openCOA() {
  //     this.hideSumRow = true;
  //     this.hideBottomSumRow = true;
  //     this.$router.push(
  //       `/settings?companyId=${this.$route.query.companyId}&coa=true`
  //     );
  //   },
  //   async uploadExcel() {
  //     try {
  //       let loader = this.$loading.show();
  //
  //       const table = this.doc;
  //
  //       loader.hide();
  //
  //       return table;
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   },
  //   async uploadBalanceSheetExcel() {
  //     try {
  //       let loader = this.$loading.show();
  //
  //       const table = this.balanceSheetDoc;
  //
  //       loader.hide();
  //
  //       return table;
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   },
  //   async uploadTrialBalanceExcel() {
  //     try {
  //       let loader = this.$loading.show();
  //
  //       const table = this.trialBalanceDoc;
  //
  //       loader.hide();
  //
  //       return table;
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   },
  //   downloadDoc(stateStart, stateEnd) {
  //     const start = stateStart
  //       ? stateStart
  //       : this.companyLayout.financialYearStartDate
  //       ? moment(
  //           this.companyLayout.financialYearStartDate,
  //           "DD-MM-yyyy"
  //         ).format("yyyy-MM-DD")
  //       : "2022-01-01";
  //     const end = stateEnd ? stateEnd : moment().format("yyyy-MM-DD");
  //     axios.defaults.headers.common["Authorization"] =
  //       "Bearer " + sessionStorage.getItem("token");
  //     axios.defaults.headers.common["X-Timezone-Offset"] = (
  //       new Date().getTimezoneOffset() / 60
  //     ).toString();
  //     axios
  //       .get(
  //         `/api/v1/income-statement/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}&typeReport=null`
  //       )
  //       .then((response) => {
  //         this.doc = response.data.list;
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   },
  //   downloadBalanceSheetDoc(stateStart, stateEnd) {
  //     const start = stateStart
  //       ? stateStart
  //       : this.companyLayout.financialYearStartDate
  //       ? moment(
  //           this.companyLayout.financialYearStartDate,
  //           "DD-MM-yyyy"
  //         ).format("yyyy-MM-DD")
  //       : "2022-01-01";
  //     const end = stateEnd ? stateEnd : moment().format("yyyy-MM-DD");
  //     axios.defaults.headers.common["Authorization"] =
  //       "Bearer " + sessionStorage.getItem("token");
  //     axios.defaults.headers.common["X-Timezone-Offset"] = (
  //       new Date().getTimezoneOffset() / 60
  //     ).toString();
  //     axios
  //       .get(
  //         `/api/v1/balance-sheet/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`
  //       )
  //       .then((response) => {
  //         this.balanceSheetDoc = response.data.list;
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   },
  //   downloadTrialBalanceDoc(stateStart, stateEnd) {
  //     const start = stateStart
  //       ? stateStart
  //       : this.companyLayout.financialYearStartDate
  //       ? moment(
  //           this.companyLayout.financialYearStartDate,
  //           "DD-MM-yyyy"
  //         ).format("yyyy-MM-DD")
  //       : "2022-01-01";
  //     const end = stateEnd ? stateEnd : moment().format("yyyy-MM-DD");
  //     axios.defaults.headers.common["Authorization"] =
  //       "Bearer " + sessionStorage.getItem("token");
  //     axios.defaults.headers.common["X-Timezone-Offset"] = (
  //       new Date().getTimezoneOffset() / 60
  //     ).toString();
  //     axios
  //       .get(
  //         `/api/v1/trial-balance/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`
  //       )
  //       .then((response) => {
  //         this.trialBalanceDoc = response.data.list;
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   },
  //   async downloadPdf() {
  //     let loader = this.$loading.show();
  //
  //     const table = this.doc;
  //
  //     loader.hide();
  //
  //     let pdfName = `${Math.floor(Date.now() / 1000)}`;
  //     const doc = new jsPDF("l", "pt", "a4");
  //     // doc.text(`${this.results.type.toUpperCase()} Autism Screener`, 15, 10)
  //
  //     const body = [];
  //     table.forEach((val, index) => {
  //       const item = [
  //         val.type,
  //         val.class,
  //         val.group,
  //         val.account,
  //         val.amount,
  //         val.sortOrder,
  //       ];
  //       body.push(item);
  //     });
  //
  //     doc.autoTable({
  //       bodyStyles: { fontSize: 7 },
  //       margin: { top: 5, left: 5, right: 5, bottom: 0 },
  //       head: [["Type", "Class", "Group", "Account", "Amount"]],
  //       body: body,
  //     });
  //
  //     // doc.autoTable({
  //     //
  //     // })
  //
  //     // doc.save(pdfName + '.pdf')
  //     // doc.setFontSize(5)
  //     // doc.autoPrint();
  //     doc.output("dataurlnewwindow");
  //   },
  //   async downloadBalanceSheetPdf() {
  //     let loader = this.$loading.show();
  //
  //     const table = this.balanceSheetDoc;
  //
  //     loader.hide();
  //
  //     let pdfName = `${Math.floor(Date.now() / 1000)}`;
  //     const doc = new jsPDF("l", "pt", "a4");
  //
  //     const body = [];
  //     table.forEach((val, index) => {
  //       const item = [val.type, val.class, val.group, val.account, val.amount];
  //       body.push(item);
  //     });
  //
  //     doc.autoTable({
  //       bodyStyles: { fontSize: 7 },
  //       margin: { top: 5, left: 5, right: 5, bottom: 0 },
  //       head: [["Type", "Class", "Group", "Account", "Amount"]],
  //       body: body,
  //     });
  //
  //     doc.output("dataurlnewwindow");
  //   },
  //   async downloadTrialBalancePdf() {
  //     let loader = this.$loading.show();
  //
  //     const table = this.trialBalanceDoc;
  //
  //     loader.hide();
  //
  //     let pdfName = `${Math.floor(Date.now() / 1000)}`;
  //     const doc = new jsPDF("l", "pt", "a4");
  //     // doc.text(`${this.results.type.toUpperCase()} Autism Screener`, 15, 10)
  //
  //     const body = [];
  //     table.forEach((val, index) => {
  //       const item = [
  //         val.type,
  //         val.class,
  //         val.group,
  //         val.account,
  //         val.credit,
  //         val.debit,
  //         val.amount,
  //         val.sortOrder,
  //       ];
  //       body.push(item);
  //     });
  //
  //     doc.autoTable({
  //       bodyStyles: { fontSize: 7 },
  //       margin: { top: 5, left: 5, right: 5, bottom: 0 },
  //       head: [["Type", "Class", "Group", "Account", "Credit", "Debit"]],
  //       body: body,
  //     });
  //
  //     // doc.autoTable({
  //     //
  //     // })
  //
  //     // doc.save(pdfName + '.pdf')
  //     // doc.setFontSize(5)
  //     // doc.autoPrint();
  //     doc.output("dataurlnewwindow");
  //   },
  //   openIncomeStatementModal() {
  //     const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
  //     const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
  //     this.$refs.generalLedgerIncomeStatementModal.openModal(start, end);
  //   },
  //   setFilter(val) {
  //     if (!val) {
  //       this.filter.dates = [];
  //     } else {
  //       const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
  //       const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
  //       this.loadList(start, end);
  //       this.downloadDoc(start, end);
  //       this.downloadBalanceSheetDoc(start, end);
  //       this.downloadTrialBalanceDoc(start, end);
  //       this.filter.asAtDate = moment(this.filter.dates[1]);
  //     }
  //   },
  //   setAsAtFilter(val) {
  //     this.filter.dates = [Number(moment(this.filter.dates[0]).format('x')), Number(moment(val).format('x'))]
  //     const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
  //     const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
  //     this.loadList(start, end);
  //     this.downloadDoc(start, end);
  //     this.downloadBalanceSheetDoc(start, end);
  //     this.downloadTrialBalanceDoc(start, end);
  //   },
  //   toggleColumns(showColumns, hideColumns, index) {
  //     console.log("this.filters.shownColumns", this.filters.shownColumns);
  //     const isFind = this.filters.shownColumns.some((x) => x === index);
  //     this.gridColumnApi.setColumnsVisible(showColumns, isFind);
  //     this.gridColumnApi.setColumnsVisible(hideColumns, !isFind);
  //     this.gridApi.sizeColumnsToFit();
  //
  //     this.gridColumnApi2.setColumnsVisible(showColumns, isFind);
  //     this.gridColumnApi2.setColumnsVisible(hideColumns, !isFind);
  //     this.gridApi2.sizeColumnsToFit();
  //   },
  //   async getCurrencies() {
  //     try {
  //       const { data } = await axios.get(`https://api.fastforex.io/currencies?api_key=${FASTFOREX_API_KEY}`)
  //       console.log('response--', data.currencies)
  //       for (const key in data.currencies) {
  //         this.currencies.push({id: key, name: data.currencies[key]})
  //       }
  //     } catch (err) {
  //       console.log(err)
  //     }
  //   },
  //   async changeCurrency(foreignCurrency) {
  //     try {
  //       let loader = this.$loading.show();
  //       // get uniques currencies
  //       const uniquesCurrencies = [...new Set(this.allRowData.filter(val => val.currencycode).map(bal => bal.currencycode))]
  //       const convertedArray = []
  //
  //       for (let i = 0; i < uniquesCurrencies.length; i++) {
  //         const { data } = await axios.get(`https://api.fastforex.io/fetch-one?from=${uniquesCurrencies[i]}&to=${foreignCurrency}&api_key=${FASTFOREX_API_KEY}`)
  //         convertedArray.push(data)
  //       }
  //
  //       this.rowData = await this.setForeignCurrencies(this.rowData, convertedArray, foreignCurrency)
  //       this.rowData2 = await this.setForeignCurrencies(this.rowData2, convertedArray, foreignCurrency)
  //
  //       loader.hide()
  //       console.log('foreignCurrency', foreignCurrency)
  //     } catch (err) {
  //       console.log(err)
  //     }
  //   },
  //   setForeignCurrencies(rowData, convertedArray, foreignCurrency) {
  //     console.log('rowData, convertedArray', rowData, convertedArray)
  //     const rowDataCopy = [...rowData]
  //     return new Promise((resolve, reject) => {
  //       convertedArray.map(val => {
  //         rowDataCopy.forEach(row => {
  //           if (val.base === row.currencycode) {
  //             row.exchangeRate = val.result[foreignCurrency]
  //             row.foreignBalance = row.endingBalance ? row.endingBalance * val.result[foreignCurrency] : 0
  //           }
  //         })
  //       })
  //       resolve(rowDataCopy)
  //     })
  //   },
  //   disabledDueDate (time) {
  //     if (this.filter.dates[0]) {
  //       let start = time.getTime() < Number(moment(this.filter.dates[0]).format('x'));
  //       if (start){
  //         return start
  //       }
  //     }
  //   },
  //   handleTabClick(tab, event) {
  //     switch (tab.name) {
  //       case 'summary':
  //         console.log('ss')
  //         break;
  //       case 'details':
  //         this.$refs.details.loadList()
  //         break;
  //     }
  //   }
  // },
  // watch: {
  //   "companyLayout.financialYearStartDate": {
  //     handler(val) {
  //       if (!this.isBalanceSheet) {
  //         this.filter.dates = [
  //           this.companyLayout.financialYearStartDate
  //             ? moment(this.companyLayout.financialYearStartDate, "DD-MM-yyyy")
  //             : moment("2022-01-01", "DD-MM-yyyy"),
  //           moment(),
  //         ];
  //         this.downloadDoc(
  //           this.filter.dates[0].format("yyyy-MM-DD"),
  //           this.filter.dates[1].format("yyyy-MM-DD")
  //         );
  //         this.downloadBalanceSheetDoc(
  //           this.filter.dates[0].format("yyyy-MM-DD"),
  //           this.filter.dates[1].format("yyyy-MM-DD")
  //         );
  //         this.downloadTrialBalanceDoc(
  //           this.filter.dates[0].format("yyyy-MM-DD"),
  //           this.filter.dates[1].format("yyyy-MM-DD")
  //         );
  //         this.loadList(
  //           this.filter.dates[0].format("yyyy-MM-DD"),
  //           this.filter.dates[1].format("yyyy-MM-DD")
  //         );
  //         this.isBalanceSheet = true;
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  beforeRouteLeave(to, from, next) {
    this.hideSumRow = true;
    this.hideBottomSumRow = true;
    // console.log('liner1', this.liner1)
    // console.log('liner4', this.liner4)
    if (this.isVisible) {
      // this.liner1.remove()
      // this.liner2.remove()
      // this.liner3.remove()
      // this.liner4.remove()
    }
    if (this.isBottomVisible) {
      // this.liner5.remove()
      // this.liner6.remove()
    }
    next();
  },
};

// const rounded = (number) => {
//   return +number.toFixed(2);
// };
</script>

<style lang="less" scoped>
/deep/.el-tabs__content {
  background: transparent;
}
.general-ledger {
  background: #fff;
  height: 100vh;
  z-index: 0;
  &.collapsed {
    height: 100vh;
    overflow: hidden;
  }
}
.setting-component {
  padding: 60px 10px 10px 10px;
  &__filter-block {
    .tabs-wrapper {
      position: relative;
      .buttons-block {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}
</style>
